import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { useState as o, useRef as b, useCallback as w, useEffect as O } from "react";
import E from "../assets/placeholder.svg.es.js";
import { classes as l } from "../utils/component.es.js";
import y from "./FadeTransition.es.js";
import k from "./LazyMedia.es.js";
import L from "./LoadingOverlay.es.js";
const A = ({
  imageUrl: a,
  animationUrl: d,
  showImageOnly: N = !1,
  className: f,
  mediaClassName: j,
  style: m,
  mediaStyle: M,
  loadingImageStyle: u,
  loadingImageClassName: h,
  contentTypeOverride: R
}) => {
  const [s, t] = o(!0), [e, i] = o(!1), [p, n] = o(!1), v = b(null), x = b(null), z = w(() => {
    t(!1), n(!0), i(!1);
  }, []), _ = w(() => {
    t(!1), i(!0), n(!1);
  }, []);
  O(() => {
    t(!0), i(!1), n(!1);
  }, [a, d]);
  const g = d || a;
  return g ? /* @__PURE__ */ r(
    "div",
    {
      className: l(
        "rcl--relative rcl--flex rcl--size-full rcl--max-h-full rcl--min-h-fit rcl--max-w-full rcl--items-center rcl--justify-center",
        f,
        /**
         * @note force the container to be square during load and error states
         * so that the media is in the top left corner for intersection observer
         * but the placeholder is square and fully visible.
         */
        (s || e) && "rcl--aspect-square"
      ),
      style: m,
      children: /* @__PURE__ */ c("div", { className: "rcl--flex rcl--size-full rcl--flex-col rcl--items-center rcl--justify-center rcl--gap-2", children: [
        /* @__PURE__ */ r(
          L,
          {
            show: s
          },
          "loading"
        ),
        /* @__PURE__ */ r(
          y,
          {
            in: !(p || e),
            unmountOnExit: !0,
            nodeRef: v,
            children: /* @__PURE__ */ r(
              "div",
              {
                ref: v,
                className: l(
                  "rcl--absolute rcl--h-[0] rcl--w-full rcl--pb-[100%]",
                  h
                ),
                style: u,
                children: /* @__PURE__ */ c("div", { className: "rcl--relative rcl--overflow-hidden", children: [
                  /* @__PURE__ */ r(
                    "img",
                    {
                      src: E,
                      alt: "loading placeholder"
                    }
                  ),
                  /* @__PURE__ */ r("div", { className: "rcl--absolute rcl--inset-0 rcl--translate-x-[-100%] rcl--animate-[shimmer_2s_infinite] rcl--bg-gradient-to-r rcl--from-transparent rcl--via-white/20 rcl--to-transparent" })
                ] })
              }
            )
          }
        ),
        e ? /* @__PURE__ */ r(
          y,
          {
            in: e,
            unmountOnExit: !0,
            nodeRef: x,
            children: /* @__PURE__ */ r("div", { ref: x, children: " Media Error" })
          }
        ) : /* @__PURE__ */ r(
          k,
          {
            src: g,
            poster: a,
            showImageOnly: N,
            onLoad: z,
            onError: _,
            contentTypeOverride: R,
            className: l(j),
            style: { ...M, opacity: p ? 1 : 0 }
          }
        )
      ] })
    }
  ) : /* @__PURE__ */ c(
    "div",
    {
      className: l(
        "rcl--relative rcl--flex rcl--size-full rcl--max-h-full rcl--min-h-fit rcl--max-w-full rcl--flex-col rcl--items-center rcl--justify-center rcl--gap-2",
        f,
        "rcl--aspect-square"
      ),
      style: m,
      children: [
        /* @__PURE__ */ r(
          L,
          {
            show: s
          },
          "loading"
        ),
        /* @__PURE__ */ r(
          "div",
          {
            className: l(
              "rcl--absolute rcl--block rcl--h-[0] rcl--w-full rcl--pb-[100%]",
              h
            ),
            style: u,
            children: /* @__PURE__ */ c("div", { className: "rcl--relative rcl--overflow-hidden", children: [
              /* @__PURE__ */ r(
                "img",
                {
                  src: E,
                  alt: "loading placeholder"
                }
              ),
              /* @__PURE__ */ r("div", { className: "rcl--absolute rcl--inset-0 rcl--translate-x-[-100%] rcl--animate-[shimmer_2s_infinite] rcl--bg-gradient-to-r rcl--from-transparent rcl--via-white/20 rcl--to-transparent" })
            ] })
          }
        )
      ]
    }
  );
};
export {
  A as default
};
//# sourceMappingURL=MediaDisplay.es.js.map
